<!-- /src/views/Relationships.vue -->
<template>
  <LayoutFullWidth class="landing--page">
    <template v-slot:header>
      <h1 id="page-header" class="page-header">Corporate Relationships</h1>
      <div class="card-grid-header__actions button__group">
        <button
            :class="{'button--accent': showMVP}"
            @click="getMVP(showMVP)"
          ><span>{{ showMVPText }}</span>
        </button>

        <button
            class=""
            @click="toggleFilters()"
          ><span v-if="activeQueries.length > 0">Modify Filtered Results</span>
            <span v-else>Filter Results</span>
        </button>
        <button @click="switchListType('cards')" :class="{ 'is-active': cardListStyleOptions['cards'] }"><i class="fas fa-th"></i></button>
        <button @click="switchListType('list')" :class="{ 'is-active': cardListStyleOptions['list'] }"><i class="fas fa-list-ul"></i></button>
        <span>
          <Sort :defaultSort="'title+rendered'"/>
        </span>
      </div>
    </template>
    <template v-slot:content>
      <div class="main-content">
        <div class="filter-panel"
          v-show="showFilters"
        >
          <Filters :postType="sessionType" />
          <button
            class="button button--gray button--medium button--accent"
            @click="toggleFilters()"
          >Close Filter Panel</button>
        </div>
        <header class="card-grid-header">
          <ActiveQueries />
        </header>
        <Loader v-if="isLoading" color="gray" />
        <NoResults v-else-if="cardCount == 0" />
        <template v-else="cardCount > 0">
          <template v-if="cardListStyleOptions['list'] == true">
            <Listing :listing="pageCards" :removeElements="removeListItemElements" />
          </template>
          <template v-else-if="cardListStyleOptions['cards'] == true">
            <LogoGrid :cards="pageCards" />
          </template>
          <Pagination v-if="totalPages > 1" :page="page" :total="totalPages" />
        </template>
      </div>
    </template>
  </LayoutFullWidth>
</template>

<script>
// import LayoutTwoColumn from '@/components/layouts/TwoColumn-SidebarNarrow'
import defaults from 'lodash/defaults'
import _sortBy from 'lodash/sortBy'

import LayoutFullWidth from '@/components/layouts/FullWidth'
import ActiveQueries from '@/components/common/Search/ActiveQueries'
import { dynamicSort, deepSearch } from '@/components/common/utils/helpers.js'
import Listing from '@/components/common/List/Listing'
import LogoGrid from '@/components/common/Card/LogoGrid'
import Sort from '@/components/common/Sort'
import Filters from '@/components/common/Sidebar/Filters'
import Pagination from '@/components/common/Pagination'
import searchMixin from '@/mixins/searchMixin'
import Loader from '@/components/common/Loaders/Loader'
import NoResults from '@/components/common/Loaders/NoResults'

export default {
  name: 'relationships',
  data() {
    return {
      showFilters: false,
      cardCount: 0,
      noCards: false,
      sessionType: 'relationships',
      loadingFeatured: false,
      showMVP: false,
      showMVPText: 'Show MVP Only',
      // showAll: false,
      // bookmarkArray: [],
      cardListStyleOptions: {
        cards: true,
        list: false,
      },
      removeListItemElements: ['icon', 'bookmarks', 'progressStatus'],
    }
  },

  computed: {
    // showMVPText() {
    //   const { ...query } = this.$route.query
    //   console.log(query['mvp'])
    //   console.log(query['mvp'] != 'undefined' && query['mvp'] == 'true')
    //   return typeof query['mvp'] != 'undefined' && query['mvp'] == 'true' ? 'Show All' : 'Show MVP Only'
    // },

    page() {
      const { page } = Object.create(this.$route.query)
      return typeof page != 'undefined' ? page : 1
    },

    isLoading() {
      return !this.$store.getters['posts/postResultsLoaded']('relationships')
    },

    // type() {
    //   return this.$store.getters['posts/getTypeInfo'](
    //     this.sessionType
    //   )
    // },
    // defines the cards displayed on page
    featured() {
      const featured = this.$store.getters['options/getOptionPosts'](
        'featuredRelationships',
      )
      return featured
    },
    cards() {
      const { sessionType, $route } = this
      const { query } = $route
      let cards = Object.create(
        this.$store.getters['posts/getAll'](sessionType),
      )
      if (cards.length > 0) this.cardCount = cards.length

      if (typeof query['industries'] != 'undefined') cards = cards.sort((a, b) => deepSearch(b, ['acf', 'is_mvp']) - deepSearch(a, ['acf', 'is_mvp']) )

      // console.log(cards.length)
      // the order of these functions is important since sorting needs to happen after input search
      // cards = this.defaultSort(['title', 'rendered'], cards)
      // cards = this.searchViaInput(cards)
      // cards = this.filterCards(cards)
      
      // if (cards.length == 0) {
      //   this.checkCards()
      // }
      // console.log('cards', cards)
      return cards
    },
    pageCards() {
      return this.cards
    },

    itemsPerPage() {
      return this.$store.getters['posts/getItemsPerPage'](this.sessionType)
    },

    totalPages() {
      return this.$store.getters['posts/getTotalPages'](this.sessionType)
    },
    bookmarkArray() {
      return this.$store.getters['user/getBookmarksOfType']('relationships').map(
        item => item.id,
      )
    }
  },

  watch: {
    featured() {
      this.loadingFeatured = true
      if (this.featured.length > 0) this.loadingFeatured = false
    },

    cards(newCards) {
      this.noCards = newCards.length == 0
      return newCards
    },

    $route(newRoute, old) {
      this.getMVPText()
    }
  },

  methods: {
    checkCards() {
      setTimeout(() => {
        if (this.cards.length == 0) this.noCards = true
      }, 5000)
    },

    defaultSort(sortBy, array) {
      return array.sort(dynamicSort(sortBy))
    },
    // changed showall to show bookmarks on page
    // processPageCards() {
    //   if (this.showAll) {
    //     return this.cards
    //   } else {
    //     return this.getBookmarks()
    //   }
    // },
    // processPageCards() {
    //   if (this.showAll) {
    //     return this.cards
    //   } else {
    //     return this.cards.slice(
    //       (this.page - 1) * this.itemsPerPage,
    //       (this.page - 1) * this.itemsPerPage + this.itemsPerPage,
    //     )
    //   }
    // },

    getMVPText() {
      const { ...query } = this.$route.query
      if (typeof query['mvp'] != 'undefined') {
        this.showMVPText = 'Show All'
        this.showMVP = true
      } else {
        this.showMVP = false
        this.showMVPText = 'Show MVP Only'
      }

    },

    toggleFilters() {
      this.showFilters = !this.showFilters
    },


    getBookmarks() {
      return this.$store.getters['posts/findAllPostsByProp'](
        this.bookmarkArray,
      )
    },

    showBookmarks() {
      return this.getBookmarks()
    },

    // showAllClicked() {
    //   this.showAll = !this.showAll
    //   this.pageCards = this.processPageCards()
    //   // this.pageCards = this.processPageCards()
    // },

    switchListType(val) {
      const { cardListStyleOptions } = this
      Object.keys(cardListStyleOptions).forEach(key => {
        cardListStyleOptions[key] = (key == val) ? true : false
      })
    },

    getMVP(bool) {      
      // @todo fix load screen as well as this button
      // @todo fix sorting for all pages using WPAPI
      const { name } = this.$route
      let queryModifier = {}
      let { ...query } = this.$route.query
      // console.log(query)
      if (typeof query['mvp'] == 'undefined') {
        queryModifier['mvp'] = true
      } else {
        delete queryModifier['mvp']
      }
      // clean up query to only include sorting options
      // console.log(typeof query['sort'] != 'undefined')
      // console.log(query['sort'])
      if (typeof query['sort'] != 'undefined') {
        queryModifier['sort'] = query['sort']
      } 
      queryModifier['page'] = 1
      // console.log(queryModifier)
      // console.log(query)
      query = queryModifier
      // console.log(query)
      this.$router.push({
        name,
        query,
      })

    }
  },

  mounted() {
    this.getMVPText()
    this.checkCards()
    // this.cards = this.getCards()
    this.$store.dispatch('updatePageTitle', 'Corporate Relationships')
  },

  beforeMount() {
    // this.sessionType = this.getSessionType()
    // this.bookmarkArray = this.$store.getters['user/getBookmarksOfType']('relationships').map(
    //   item => item.id,
    // )
    
  },

  mixins: [searchMixin],

  components: {
    LayoutFullWidth,
    ActiveQueries,
    LogoGrid,
    Listing,
    Pagination,
    Filters,
    Sort,
    Loader,
    NoResults,
  },
}
</script>

<style scoped>

.main-content {
  height: 100%;
}

.card-grid-header {
  width: 100%;
  display: grid;
  /* grid-template-columns: 1fr; */
  /* justify-items: end; */
  margin-bottom: 0.25rem;

  h2 {
    margin-bottom: 0;
  }

  &__actions {
    display: inline-block;
    font-size: 0.7em;
    div {
      display: inline-block;
    }

    button {
      background-color: var(--gray);
      padding: .5em;
      color: white;
      margin-right: .5em;
      border-radius: 4px;
      font-weight: 700;
      transition: background 300ms;
      border: none;

      &.is-active {
        background-color: var(--brandPrimary);
      }

      &:hover {
        background-color: var(--brandAccent);
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}


.filter-panel {
  display: grid;
  margin-bottom: 1rem;
  padding: 1rem;
  gap: 1rem;
  background-color: rgba(var(--gray-RGB), .3);
  border-radius: 4px;

  &> button {
    justify-self: end;
    font-size: .6rem;
    padding: .35rem .5rem;
  }
}



</style>
